import React from "react";
import { FiTrash } from "react-icons/fi";

interface IDeleteButtonProps {
  onClick?: () => void;
  className?: string;
  ariaLabel?: string;
  disabled?: boolean;
}

const DeleteButton: React.FC<IDeleteButtonProps> = ({
  onClick,
  className = "",
  ariaLabel = "Delete",
  disabled = false,
}) => {
  return (
    <button
      aria-label={ariaLabel}
      aria-disabled={disabled}
      disabled={disabled}
      onClick={disabled ? undefined : onClick}
      className={`inline-flex h-9 w-9 items-center justify-center rounded-lg text-red-600 transition ${
        disabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-red-500/10"
      } ${className}`}
    >
      <FiTrash size={16} style={{ color: "#dc2626" }} />
    </button>
  );
};

export { DeleteButton };
